export default __webpack_public_path__ + "static/media/slab-grey.2aaef1de.png";